module.exports = __webpack_public_path__ + "static/img/1.a2b55f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/1.jpg
// module id = 6Ma3
// module chunks = 1